import Cookies from "js-cookie";
import $ from "cash-dom";

(function ($) {
  const defaultButtons = $(".login-link, .signup-button");
  const logOutButton = $(".btn-logout");
  const loginSignupContainer = $(".login-signup-container");
  const accountWrapper = $(".account-info-wrapper");
  const accountInfo = $(".account-info");
  const footerAccountWrapper = $(".customer-support-logged-user");
  const footerCustomerService = $(".customer-service-wrapper");
  $(".btn-logout").on("click", async function (e) {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://www.neighborwho.com/api/v5/session",
        {
          method: "DELETE",
          credentials: "include",
        },
      );
      if (response.ok) {
        Cookies.remove("loggedin");
        Cookies.remove("loggedinas");
        Cookies.remove("full_name");
        Cookies.remove("user_code");
        footerAccountWrapper.addClass("is-hidden");
        footerAccountWrapper.find(".account-member-id span").text("");
        accountWrapper.addClass("is-hidden");
        logOutButton.addClass("is-hidden");
        accountInfo.addClass("is-hidden");
        footerCustomerService.removeClass("is-hidden");
        loginSignupContainer.removeClass("is-hidden");
        defaultButtons.removeClass("is-hidden");
      }
    } catch (err) {
      console.log(err);
    }
  });
  $(".has-tooltip").on("click", function (e) {
    e.preventDefault();
    const tooltip = $(this).find(".tooltip");
    const clipboardText = $(this).find("span").text();
    navigator.clipboard.writeText(clipboardText);
    $(tooltip).text("copied to clipboard.");
  });
  $(".has-tooltip").on("mouseout", function () {
    const tooltip = $(this).find(".tooltip");
    tooltip.text("Click to copy.");
  });
})($);
